export const ROUTES = {
	HOME: "/",
	404: "/404",
	AIA: {
		REGISTER: "/aia/register",
		CONSULT: "/aia/consult",
		EDIT: "/aia/edit",
	},
	EPS: {
		REGISTER: "/eps/register",
		CONSULT: "/eps/consult",
		EDIT: "/eps/edit",
	},
	GLOSSARY: {
		CONSULT: "/glossary/consult",
		REGISTER: "/glossary/register",
		EDIT: "/glossary/edit",
	},
	AREA: {
		REGISTER: "/area/register",
		CONSULT: "/area/consult",
		EDIT: "/area/edit",
	},
	SECTION: {
		REGISTER: "/section/register",
		CONSULT: "/section/consult",
		EDIT: "/section/edit",
	},
	QUESTION: {
		REGISTER: "/question/register",
		EDIT: "/question/edit",
		CONSULT: "/question/consult",
	},
	QUESTIONNAIRE: {
		REGISTER: {
			AIA: "/questionnaire/aia/register",
			EPS: "/questionnaire/eps/register",
		},
		ANSWER: {
			AIA: "/questionnaire/aia/answer",
			EPS: "/questionnaire/eps/answer",
		},
	},
	ORGANIZATION: {
		CONSULT: "/organization/consult",
		PROFILE: "/organization/profile",
	},
	APPLICATION: {
		CONSULT: "/application/consult",
		EVALUATE: "/application/evaluate",
		DELIBERATE: "/application/deliberate",
	},
	PRINCIPLE: {
		REGISTER: "/principle/register",
		CONSULT: "/principle/consult",
		EDIT: "/principle/edit",
	},
	USER: {
		CONSULT: "/user/consult",
		REGISTER: "/user/register",
		EDIT: "/user/edit",
	},
	AUTH: {
		ACCOUNT_ACTIVATION: "/auth/account-activation",
		FORGOT_PASSWORD: "/auth/forgot-password",
		LOGIN: "/auth/login",
		NEW_ACCOUNT: "/auth/new-account",
		PASSWORD_RESET: "/auth/password-reset",
		PROFILE: "/auth/profile",
		"NO-TOKEN": "/auth/no-token",
	},
	ABOUT: "/about",
	TERMS_AND_CONDITIONS: "/terms-and-conditions",
	PRIVACY_POLITICS: "/privacy-policies",
} as const;

export const AUTH_ROUTES = [
	ROUTES.AUTH.LOGIN,
	ROUTES.AUTH.ACCOUNT_ACTIVATION,
	ROUTES.AUTH.FORGOT_PASSWORD,
	ROUTES.AUTH.NEW_ACCOUNT,
	ROUTES.AUTH.PASSWORD_RESET,
];

export const PUBLIC_ROUTES = [
	ROUTES.HOME,
	ROUTES.AUTH.LOGIN,
	ROUTES.AUTH.FORGOT_PASSWORD,
	ROUTES.AUTH.NEW_ACCOUNT,
	ROUTES.AUTH.PASSWORD_RESET,
	ROUTES.PRIVACY_POLITICS,
	ROUTES.TERMS_AND_CONDITIONS,
];
